"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IframeBubble = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const react_3 = require("react");
const services_1 = require("../../../services");
const store_1 = require("../../../store");
const HostBubble_1 = require("../HostBubble");
const IframeBubble = ({ message, onTypingEnd, }) => {
    const chatbot = (0, store_1.useStoreState)((state) => state.chatbot.value);
    const [typing, setTyping] = (0, react_1.useState)(true);
    const iframe = (0, react_3.useRef)(null);
    const params = message.params;
    const height = (params === null || params === void 0 ? void 0 : params.height) ? `${params.height}px` : "600px";
    (0, react_2.useEffect)(() => {
        showContentAfterMediaLoad();
    }, []);
    const showContentAfterMediaLoad = () => {
        if (!iframe.current)
            return;
        const timeout = setTimeout(() => {
            setTyping(false);
            onTypingEnd();
        }, HostBubble_1.mediaLoadingFallbackTimeout);
        iframe.current.onload = () => {
            clearTimeout(timeout);
            setTyping(false);
            onTypingEnd();
        };
    };
    return (react_1.default.createElement("iframe", { src: (0, services_1.parseVariables)(message.content, chatbot.variables), className: "w-full p-4 content-opacity z-10", height: typing ? "2rem" : height, ref: iframe, allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true }));
};
exports.IframeBubble = IframeBubble;
//# sourceMappingURL=IframeBubble.js.map